export default __webpack_public_path__ + "static/media/part_3_con_04.d7846c7c.gif";